import React from 'react';

const Declaration = () => {
  return (
    <div>
      <p className="font-bold text-center pb-4">1. ОБЩИЕ ПОЛОЖЕНИЯ</p>
      <p className="pb-2 indent-0">
        1.1. Настоящее Пользовательское соглашение (далее – Соглашение) регулирует отношения между Обществом с ограниченной ответственностью «МЕРИДИАН» (ОГРН:
        5087746158880, ИНН: 7734592378, юридический адрес: г. Москва, ул. Малая Калужская, д. 15, стр. 17, далее – Компания) и Пользователем, возникающие в
        процессе использования цифровой платформы учёта (далее – Платформа). Платформа включает веб-интерфейсы, расположенные по адресам:{' '}
        <a href="https://meridian.pro" target="_blank" rel="noopener noreferrer">
          https://meridian.pro
        </a>{' '}
        и{' '}
        <a href="https://lk.meridian.pro" target="_blank" rel="noopener noreferrer">
          https://lk.meridian.pro
        </a>{' '}
        и{' '}
        <a href="https://lk2.meridian.pro" target="_blank" rel="noopener noreferrer">
          https://lk2.meridian.pro
        </a>
        , а также мобильные приложения Компании для iOS и Android (совместно – Программы).
      </p>
      <p className="pb-2 indent-0">1.2. Для целей настоящего Соглашения используются следующие понятия:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>
          «Пользователь» – физическое или юридическое лицо, зарегистрированное на Платформе и (или) использующее Программы либо Устройство;
        </li>
        <li>
          «Устройство» – устройство автоматизированного сбора и передачи показаний приборов учёта под товарным знаком Kolibri, включая модификации Kolibri Wi-Fi и
          Kolibri NB-IoT;
        </li>
        <li>
          «Программное обеспечение» – мобильное приложение, личный кабинет, облачный сервис mira.cloud и иные программные компоненты, используемые совместно с
          Устройством;
        </li>
        <li>«Система» – Устройство и Программное обеспечение в совокупности;</li>
        <li>
          «Получатель показаний» – управляющая, ресурсоснабжающая организация, товарищество собственников жилья, расчётный центр или иное лицо, осуществляющее
          приём и обработку показаний приборов учёта;
        </li>
        <li>«Kolibri Wi-Fi» – модификация Устройства, передающая данные посредством подключения к Wi-Fi-сети Пользователя и сети Интернет;</li>
        <li>
          «Kolibri NB-IoT» – модификация Устройства, передающая данные с использованием сети связи стандарта NB-IoT и установленной в Устройстве SIM-карты.
        </li>
      </ul>
      <p className="pb-2 indent-0">
        1.3. Настоящее Соглашение регулирует отношения, возникающие при использовании Платформы, Программного обеспечения и Устройств, поддерживающих
        автоматизированный сбор, хранение и передачу показаний приборов учёта воды, тепловой энергии и газа.
      </p>
      <p className="pb-2 indent-0">
        1.4. Регистрация Пользователя и использование Платформы означает полное и безоговорочное согласие с условиями настоящего Соглашения.
      </p>
      <p className="pb-2 indent-0">
        1.5. Компания оставляет за собой право изменять условия настоящего Соглашения в одностороннем порядке. Обновления вступают в силу с момента размещения
        на Платформе, если не указано иное.
      </p>
      <p className="pb-2 indent-0">
        1.6. Компания принимает разумные организационные и технические меры для обеспечения функционирования Платформы, Программного обеспечения и Устройств в
        соответствии с их назначением. Технические особенности, ограничения и условия функционирования Системы устанавливаются настоящим Соглашением.
      </p>
      <p className="pb-2 indent-0">
        1.7. Пользователь несёт персональную ответственность за актуальность и достоверность переданных данных, а также за безопасность своей учётной записи и
        конфиденциальность используемых авторизационных данных.
      </p>

      <p className="font-bold text-center py-4">2. ПОРЯДОК ИСПОЛЬЗОВАНИЯ И ДОСТУПА</p>
      <p className="pb-2 indent-0">
        2.1. Доступ к Платформе осуществляется через личный кабинет на сайте или в мобильном приложении. Регистрация учётной записи является обязательной для
        доступа к функциям передачи показаний и получения уведомлений.
      </p>
      <p className="pb-2 indent-0">
        2.2. Для корректного функционирования Платформы Пользователь обязуется своевременно вводить и обновлять данные по приборам учёта, если они не
        передаются автоматически.
      </p>
      <p className="pb-2 indent-0">
        2.3. Пользователь обязуется использовать Платформу добросовестно, не нарушая прав третьих лиц, не вмешиваясь в работу системы и не осуществляя
        действий, направленных на подрыв безопасности и целостности данных.
      </p>
      <p className="pb-2 indent-0">
        2.4. Использование функционала передачи показаний осуществляется бесплатно, кроме случаев использования Устройств, передающих данные с использованием
        SIM-карты и сети NB-IoT.
      </p>
      <p className="pb-2 indent-0">
        2.5. За использование Устройства, передающего данные с использованием SIM-карты и сети NB-IoT, взимается сервисный сбор в размере 180 (ста восьмидесяти)
        рублей в год за каждое Устройство. В указанную сумму входит обеспечение подключения Устройства к сети связи, передача данных в личный кабинет
        Пользователя и направление показаний на поддерживаемые Компанией информационные ресурсы. Изменение размера сервисного сбора применяется к последующему
        периоду обслуживания после предварительного уведомления Пользователя. Оплата нового периода обслуживания означает согласие Пользователя с изменённым
        размером сервисного сбора.
      </p>
      <p className="pb-2 indent-0">
        2.6. Использование модификации Kolibri Wi-Fi и иных Устройств, не использующих SIM-карту Компании, не требует внесения сервисного сбора за передачу
        данных, если иное прямо не указано при подключении отдельной платной функции.
      </p>
      <p className="pb-2 indent-0">
        2.7. Пользователь вправе по своей инициативе предоставить Компании логин и пароль от личного кабинета управляющей компании, ТСЖ, ресурсоснабжающей или
        иной организации для целей передачи показаний приборов учёта.
      </p>
      <p className="pb-2 indent-0">
        2.8. Передача данных авторизации осуществляется исключительно добровольно и по усмотрению Пользователя. Пользователь подтверждает, что имеет надлежащие
        права на использование соответствующего личного кабинета.
      </p>
      <p className="pb-2 indent-0">
        2.9. Компания использует полученные данные исключительно для целей ввода или автоматической передачи показаний, в интересах Пользователя. Пользователь
        не изменяет иную информацию в кабинете, не вносит оплату и не передаёт эти данные третьим лицам.
      </p>
      <p className="pb-2 indent-0">2.10. Компания не несёт ответственности за последствия, вызванные:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>передачей логина и пароля самим Пользователем третьим лицам;</li>
        <li>взломом, сбоем или ограничением доступа к кабинету, произошедшими не по вине Компании;</li>
        <li>техническими ограничениями или изменениями функциональности сторонних платформ.</li>
      </ul>
      <p className="pb-2 indent-0">
        2.11. Пользователь вправе в любой момент отозвать данные доступа или изменить пароль. После отзыва доступа Компания прекращает использование
        соответствующего кабинета без необходимости дополнительных уведомлений.
      </p>
      <p className="pb-2 indent-0">
        2.12. Система является вспомогательным техническим средством, предназначенным для автоматизированного сбора, хранения и направления показаний приборов
        учёта воды, тепловой энергии и газа. Система автоматизирует передачу показаний, но не исключает необходимость контроля Пользователем сроков передачи,
        корректности собранных данных, наличия связи с Устройством, результата передачи и факта приёма показаний Получателем показаний.
      </p>
      <p className="pb-2 indent-0">
        2.13. Компания не является управляющей, ресурсоснабжающей организацией или расчётным центром, если иное прямо не предусмотрено отдельным договором.
        Компания не определяет сроки, форматы, правила, порядок приёма, проверки, обработки и использования показаний Получателем показаний.
      </p>
      <p className="pb-2 indent-0">
        2.14. Автоматизированная передача показаний осуществляется в соответствии с настройками Системы и установленным расписанием при наличии технической
        возможности.
      </p>
      <p className="pb-2 indent-0">2.15. Для осуществления передачи показаний необходимо одновременное соблюдение следующих условий:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>исправность Устройства и подключённого к нему прибора учёта;</li>
        <li>совместимость прибора учёта и Устройства;</li>
        <li>правильность монтажа, подключения и настройки;</li>
        <li>достоверность лицевого счёта, номера прибора учёта, адреса, идентификаторов и иных сведений;</li>
        <li>наличие необходимого электропитания;</li>
        <li>наличие работоспособной сети передачи данных;</li>
        <li>доступность Программного обеспечения Компании;</li>
        <li>работоспособность информационной системы Получателя показаний;</li>
        <li>соблюдение сроков, форматов и правил приёма данных, установленных Получателем показаний.</li>
      </ul>
      <p className="pb-2 indent-0">
        2.16. Пользователь самостоятельно обеспечивает выполнение условий, относящихся к оборудованию, электропитанию, услугам связи, интернет-соединению,
        настройкам, контактным и учётным данным, находящимся на стороне Пользователя.
      </p>
      <p className="pb-2 indent-0">
        2.17. Компания не гарантирует техническую возможность передачи показаний любому Получателю показаний. Актуальный перечень поддерживаемых Получателей
        показаний, регионов и способов интеграции размещается на Платформе либо предоставляется Пользователю при подключении соответствующего функционала.
        Получатель показаний вправе изменять технические требования, сроки, правила приёма данных, программные интерфейсы и способы идентификации Пользователя
        без согласования с Компанией.
      </p>
      <p className="pb-2 indent-0">
        2.18. Модификация Kolibri Wi-Fi передаёт данные посредством подключения к Wi-Fi-маршрутизатору Пользователя и сети Интернет.
      </p>
      <p className="pb-2 indent-0">Для работы модификации Kolibri Wi-Fi Пользователь обязан обеспечить:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>наличие совместимой и работоспособной Wi-Fi-сети;</li>
        <li>правильность введённых данных для подключения;</li>
        <li>достаточный уровень сигнала в месте установки;</li>
        <li>работоспособность маршрутизатора;</li>
        <li>необходимое для передачи данных электропитание маршрутизатора;</li>
        <li>активный и оплаченный доступ к сети Интернет;</li>
        <li>отсутствие блокировок, препятствующих соединению Устройства с серверами Компании.</li>
      </ul>
      <p className="pb-2 indent-0">
        2.19. Отсутствие передачи данных вследствие выключения, зависания, неисправности или неправильной настройки маршрутизатора, отсутствия электропитания,
        неоплаты доступа к сети Интернет, изменения пароля Wi-Fi, блокировки соединения либо недостаточного уровня сигнала само по себе не свидетельствует о
        неисправности Устройства.
      </p>
      <p className="pb-2 indent-0">
        2.20. Модификация Kolibri NB-IoT осуществляет передачу данных с использованием сети связи стандарта NB-IoT, предоставляемой ПАО «МТС» либо иным
        сторонним оператором связи, указанным изготовителем или продавцом Устройства. Оператор связи является самостоятельным третьим лицом.
      </p>
      <p className="pb-2 indent-0">
        2.21. Компания не управляет базовыми станциями оператора связи, не определяет территорию, параметры и качество покрытия и не гарантирует непрерывную
        доступность сети NB-IoT в конкретном месте и в каждый момент времени.
      </p>
      <p className="pb-2 indent-0">2.22. Возможность и стабильность передачи данных посредством модификации Kolibri NB-IoT зависят, в том числе, от:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>наличия покрытия NB-IoT непосредственно в месте установки Устройства;</li>
        <li>доступности и технического состояния базовых станций;</li>
        <li>поддерживаемых оператором и Устройством частотных диапазонов;</li>
        <li>расстояния до базовой станции;</li>
        <li>мощности и качества радиосигнала;</li>
        <li>расположения Устройства внутри здания;</li>
        <li>толщины стен, перекрытий и иных конструкций;</li>
        <li>нахождения Устройства в подвале, техническом помещении, нише, металлическом шкафу или ином месте, затрудняющем прохождение радиосигнала;</li>
        <li>особенностей рельефа и окружающей застройки;</li>
        <li>уровня загрузки базовой станции;</li>
        <li>настроек и конфигурации сети оператора;</li>
        <li>проведения оператором профилактических, ремонтных или технических работ;</li>
        <li>аварий, перегрузок, временных ограничений, блокировок или прекращения работы сети;</li>
        <li>действий государственных органов;</li>
        <li>иных обстоятельств, находящихся вне контроля Компании.</li>
      </ul>
      <p className="pb-2 indent-0">
        2.23. Сведения и карты покрытия, размещаемые оператором связи, имеют справочный характер и не гарантируют наличие устойчивого сигнала NB-IoT
        непосредственно в помещении или месте установки Устройства. Наличие голосовой связи, мобильного Интернета, а также сетей 2G, 3G, 4G или 5G само по себе
        не подтверждает наличие и доступность сети NB-IoT.
      </p>
      <p className="pb-2 indent-0">
        2.24. Уровень и качество сигнала могут различаться в разных зданиях, на разных этажах или в разных помещениях одного здания, а также изменяться после
        установки Устройства вследствие изменения конфигурации сети, окружающей застройки, расположения оборудования или иных внешних условий. Пользователю
        рекомендуется до окончательного монтажа проверить возможность подключения модификации Kolibri NB-IoT непосредственно в предполагаемом месте установки.
      </p>
      <p className="pb-2 indent-0">
        2.25. Система осуществляет автоматизированную попытку передачи показаний в соответствии с установленным расписанием и настройками Пользователя.
        Компания не гарантирует успешное завершение каждой попытки передачи при наличии обстоятельств, находящихся вне контроля Компании.
      </p>
      <p className="pb-2 indent-0">
        2.26. Статус «Передано успешно» означает, что Система получила техническое подтверждение отправки данных либо положительный ответ информационной
        системы Получателя показаний.
      </p>
      <p className="pb-2 indent-0">2.27. Статус «Передано успешно» сам по себе не гарантирует:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>окончательный приём и учёт показаний Получателем показаний;</li>
        <li>отражение показаний в личном кабинете Получателя показаний;</li>
        <li>использование показаний при расчёте платы;</li>
        <li>отсутствие последующего отказа в приёме, аннулирования или корректировки показаний;</li>
        <li>отсутствие задержек обмена между информационными системами третьих лиц;</li>
        <li>отсутствие ошибок на стороне Получателя показаний.</li>
      </ul>
      <p className="pb-2 indent-0">
        2.28. Статусы «Ошибка передачи», «Не передано», «Нет связи», «Нет данных» либо отсутствие подтверждённого положительного результата означают, что
        успешная передача показаний не подтверждена.
      </p>
      <p className="pb-2 indent-0">2.29. Информация о результате передачи может размещаться:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>в мобильном приложении;</li>
        <li>в личном кабинете;</li>
        <li>в журнале событий Системы;</li>
        <li>в электронном письме;</li>
        <li>в push-уведомлении;</li>
        <li>иным способом, предусмотренным функциональностью Платформы.</li>
      </ul>
      <p className="pb-2 indent-0">
        Конкретные способы уведомления зависят от версии Программного обеспечения, настроек Пользователя, технической возможности и подключённого тарифа.
      </p>
      <p className="pb-2 indent-0">
        2.30. Пользователь обязан указать действующие контактные данные, своевременно обновлять их, обеспечить возможность получения сообщений, разрешить
        получение уведомлений в настройках устройства, а также самостоятельно проверять статус передачи в приложении, личном кабинете или журнале событий.
      </p>
      <p className="pb-2 indent-0">
        2.31. Электронные письма и push-уведомления являются дополнительным способом информирования. Неполучение такого сообщения не освобождает Пользователя
        от необходимости проверить результат передачи в доступных разделах Программного обеспечения.
      </p>
      <p className="pb-2 indent-0">
        2.32. Обязанность Компании по информированию считается исполненной с момента размещения статуса операции в доступном Пользователю разделе Программного
        обеспечения либо направления уведомления по указанным Пользователем контактным данным.
      </p>
      <p className="pb-2 indent-0">
        2.33. При отсутствии подтверждения успешной передачи Пользователь обязан самостоятельно передать показания Получателю показаний иным доступным способом
        до окончания установленного срока.
      </p>
      <p className="pb-2 indent-0">
        2.34. Пользователь обязан самостоятельно проверить факт приёма и учёта показаний Получателем показаний, если такая возможность предоставляется
        Получателем показаний.
      </p>
      <p className="pb-2 indent-0">
        2.35. Для самостоятельной передачи показаний Пользователь может использовать личный кабинет, мобильное приложение или сайт Получателя показаний,
        телефон, электронную почту, терминал, платёжный документ либо иной предусмотренный Получателем показаний способ.
      </p>
      <p className="pb-2 indent-0">
        2.36. Обращение в службу технической поддержки Компании и проведение диагностики не приостанавливают срок передачи показаний. Пользователь обязан
        воспользоваться иным доступным способом передачи, даже если диагностика причины отсутствия передачи ещё не завершена.
      </p>

      <p className="font-bold text-center py-4">3. ОТВЕТСТВЕННОСТЬ СТОРОН</p>
      <p className="pb-2 indent-0">
        3.1. Компания принимает разумные организационные и технические меры для обеспечения работоспособности Устройства, Платформы и Программного обеспечения,
        однако их работа может временно ограничиваться вследствие технического обслуживания, установки обновлений, устранения ошибок, обновления серверной
        инфраструктуры, изменения интеграций с информационными системами третьих лиц и выполнения мероприятий по информационной безопасности.
      </p>
      <p className="pb-2 indent-0">
        3.2. В пределах, допускаемых законодательством Российской Федерации, Компания не несёт ответственности за непередачу, несвоевременную передачу, отказ в
        приёме, задержку или неправильную обработку показаний, если соответствующие обстоятельства возникли вследствие:
      </p>
      <ul className="list-disc pl-10 pb-2">
        <li>отсутствия или отключения электропитания;</li>
        <li>неисправности, отключения или неправильной настройки Wi-Fi-маршрутизатора;</li>
        <li>изменения наименования или пароля Wi-Fi-сети;</li>
        <li>отсутствия, блокировки или ограничения доступа к сети Интернет;</li>
        <li>неоплаты услуг интернет-провайдера;</li>
        <li>слабого или отсутствующего сигнала Wi-Fi;</li>
        <li>работы VPN, прокси-сервисов, межсетевых экранов или средств фильтрации трафика;</li>
        <li>отсутствия покрытия или необходимого уровня сигнала NB-IoT;</li>
        <li>недоступности, неисправности или перегрузки базовой станции;</li>
        <li>проведения работ или изменения конфигурации сети оператором связи;</li>
        <li>недоступности либо технических изменений информационной системы Получателя показаний;</li>
        <li>изменения Получателем показаний сроков, форматов или правил приёма данных;</li>
        <li>отказа Получателя показаний принять переданные данные;</li>
        <li>неправильного указания Пользователем лицевого счёта, номера прибора учёта, адреса или иных сведений;</li>
        <li>замены прибора учёта без обновления сведений в Системе;</li>
        <li>отсутствия регистрации или истечения срока поверки прибора учёта;</li>
        <li>неправильного монтажа, подключения или настройки Устройства;</li>
        <li>повреждения проводов, кабелей, контактов, элементов питания или разъёмов;</li>
        <li>использования несовместимого оборудования;</li>
        <li>вмешательства Пользователя или третьих лиц в работу Устройства или Программного обеспечения;</li>
        <li>несоблюдения инструкции по монтажу и эксплуатации;</li>
        <li>иных обстоятельств, находящихся вне разумного контроля Компании.</li>
      </ul>
      <p className="pb-2 indent-0">
        3.3. Компания не отвечает за недоставку электронных писем и push-уведомлений, если она вызвана работой почтового сервиса или оператора связи,
        настройками устройства Пользователя, запретом на получение уведомлений, переполнением почтового ящика, блокировкой отправителя, попаданием сообщения в
        папку «Спам», неверно указанными контактными данными или иными обстоятельствами, находящимися вне контроля Компании.
      </p>
      <p className="pb-2 indent-0">3.4. При обращении Пользователя в связи с отсутствием передачи данных Компания вправе:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>провести удалённую диагностику;</li>
        <li>запросить журналы событий и сведения о соединении;</li>
        <li>запросить информацию, фотографии или видеозаписи места установки;</li>
        <li>проверить состояние Устройства;</li>
        <li>предложить временно изменить расположение Устройства;</li>
        <li>принять Устройство для проведения проверки качества или экспертизы в предусмотренных законодательством случаях.</li>
      </ul>
      <p className="pb-2 indent-0">
        3.5. Отсутствие передачи показаний само по себе не является достаточным доказательством наличия недостатка Устройства или Программного обеспечения.
        Если по результатам проверки установлено, что Устройство технически исправно, а отсутствие передачи обусловлено состоянием сети оператора связи,
        отсутствием покрытия, условиями установки, радиопомехами, работой Получателя показаний либо иными обстоятельствами, не связанными с качеством
        Устройства, такое отсутствие передачи не признаётся недостатком Устройства и не является гарантийным случаем.
      </p>
      <p className="pb-2 indent-0">
        3.6. В случае выявления подтверждённого недостатка Устройства или Программного обеспечения Пользователь вправе обратиться в службу технической
        поддержки, к Продавцу, Изготовителю либо в уполномоченный сервисный центр и воспользоваться правами, предусмотренными законодательством Российской
        Федерации, Публичной офертой, паспортом Устройства и иной технической документацией.
      </p>
      <p className="pb-2 indent-0">
        Гарантийный срок, порядок гарантийного обслуживания и обстоятельства, при которых недостаток Устройства не относится к гарантийным случаям,
        определяются Публичной офертой и паспортом соответствующей модели Устройства.
      </p>
      <p className="pb-2 indent-0">
        Отсутствие передачи данных при технически исправном Устройстве, если оно обусловлено состоянием сети связи, отсутствием покрытия, доступа к сети
        Интернет или электропитания, условиями установки, работой Получателя показаний либо иными обстоятельствами, не связанными с качеством Устройства, не
        признаётся недостатком Устройства.
      </p>
      <p className="pb-2 indent-0">
        3.7. В пределах, допускаемых законодательством Российской Федерации, Компания не несёт ответственности за начисления по нормативу, перерасчёты, пени,
        задолженность и иные последствия непередачи показаний, если:
      </p>
      <ul className="list-disc pl-10 pb-2">
        <li>
          информация об ошибке или отсутствии передачи была своевременно и достоверно отображена в доступном Пользователю разделе Программного обеспечения либо
          направлена по предоставленным им контактным данным;
        </li>
        <li>у Пользователя имелась разумная возможность самостоятельно передать показания иным способом до окончания установленного срока;</li>
        <li>Пользователь не проверил результат передачи либо не принял мер для самостоятельной передачи показаний.</li>
      </ul>
      <p className="pb-2 indent-0">
        3.8. Пользователь несёт ответственность за сохранность реквизитов доступа, действия, совершённые с использованием его учётной записи, достоверность и
        актуальность предоставленных сведений, а также соблюдение условий настоящего Соглашения.
      </p>
      <p className="pb-2 indent-0">
        3.9. Компания применяет предусмотренные законодательством правовые, организационные и технические меры защиты информации, но не отвечает за последствия
        несанкционированного доступа, возникшего вследствие передачи Пользователем реквизитов доступа третьим лицам, использования небезопасного устройства
        либо иных действий самого Пользователя.
      </p>
      <p className="pb-2 indent-0">
        3.10. Стороны освобождаются от ответственности за неисполнение обязательств, вызванное чрезвычайными и непредотвратимыми при данных условиях
        обстоятельствами непреодолимой силы. К таким обстоятельствам могут относиться стихийные бедствия, пожары, наводнения, землетрясения, военные действия,
        террористические акты, массовые беспорядки, решения и запреты государственных органов, масштабные аварии инфраструктуры связи и электроснабжения и
        иные обстоятельства, отвечающие установленным законодательством признакам непреодолимой силы.
      </p>
      <p className="pb-2 indent-0">
        3.11. Обычные технические неисправности Устройства, Программного обеспечения, сети оператора связи, интернет-провайдера или информационной системы
        Получателя показаний сами по себе не признаются обстоятельствами непреодолимой силы без наличия признаков чрезвычайности и непредотвратимости.
      </p>
      <p className="pb-2 indent-0">
        3.12. Никакое положение настоящего Соглашения не исключает и не ограничивает права Пользователя и ответственность Компании в случаях, когда такие права
        или ответственность не могут быть исключены или ограничены соглашением сторон в силу закона.
      </p>

      <p className="font-bold text-center py-4">4. ПРАВА И ОБЯЗАННОСТИ СТОРОН</p>
      <p className="pb-2 indent-0">4.1. Пользователь вправе:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>использовать Программы, включая веб-сайт и мобильные приложения, в объёме и на условиях, предусмотренных настоящим Соглашением;</li>
        <li>задавать вопросы, направлять обращения и претензии через формы обратной связи или иные предусмотренные интерфейсы Платформы;</li>
        <li>
          получать доступ к информации о своей учетной записи, показаниям приборов учёта, истории платежей и иным функциям Программ, доступным по выбранной
          модели подключения;
        </li>
        <li>использовать данные и информацию, полученные через Программы, в личных целях;</li>
        <li>прекращать использование Программ в любой момент по собственному усмотрению, за исключением случаев наличия действующих обязательств.</li>
      </ul>
      <p className="pb-2 indent-0">4.2. Пользователь обязуется:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>
          при использовании счётчиков с передачей данных через сотовую связь, оплачивать ежегодный сервисный сбор в размере 180 (ста восьмидесяти) рублей за
          каждый такой счётчик. В указанную стоимость входит передача показаний через оператора связи, уведомления Пользователю, а также отправка показаний на
          портал mos.ru. Указанная сумма может корректироваться Компанией в одностороннем порядке в случае изменения тарифов связи и иных сопутствующих
          расходов;
        </li>
        <li>самостоятельно отслеживать статус своей учётной записи и баланс обязательных платежей в соответствующем разделе Программы;</li>
        <li>не предпринимать действий, нарушающих работу Программы, или создающих необоснованную нагрузку на инфраструктуру Компании;</li>
        <li>соблюдать нормы законодательства Российской Федерации при использовании Программы;</li>
        <li>не предпринимать попыток обхода технических ограничений, взлома, модификации или иного вмешательства в работу Программы;</li>
        <li>
          не использовать функционал Программы в целях, не предусмотренных её назначением, включая недобросовестное использование или предоставление ложной
          информации;
        </li>
        <li>
          ознакомиться с Политикой конфиденциальности и обработки персональных данных, опубликованной на Сайте, и соблюдать установленные ею требования;
        </li>
        <li>самостоятельно контролировать статус автоматизированной передачи показаний и соблюдать порядок действий, предусмотренный пунктами 2.29–2.36 настоящего Соглашения;</li>
        <li>обеспечивать технические условия использования Устройства, предусмотренные пунктами 2.15–2.24 настоящего Соглашения.</li>
      </ul>
      <p className="pb-2 indent-0">4.3. Компания вправе:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>приостанавливать или ограничивать доступ к Программам в случае нарушения Пользователем условий настоящего Соглашения;</li>
        <li>изменять функциональность Программ, обновлять интерфейс, внедрять новые функции без согласия Пользователя;</li>
        <li>публиковать уведомления, обязательные для ознакомления, в интерфейсе Программ;</li>
        <li>
          взимать плату за сервисные функции, включая передачу показаний по каналам связи, в порядке и на условиях, предусмотренных настоящим Соглашением;
        </li>
        <li>использовать обезличенные статистические данные о работе Программ и действиях Пользователей для анализа и улучшения сервиса.</li>
      </ul>
      <p className="pb-2 indent-0">4.4. Компания обязуется:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>обеспечивать функционирование Программ в соответствии с их назначением;</li>
        <li>своевременно информировать Пользователей о значимых изменениях условий обслуживания через интерфейс Программ;</li>
        <li>соблюдать требования законодательства Российской Федерации при обработке персональных данных Пользователей;</li>
        <li>предоставлять Пользователям техническую поддержку в объёме, предусмотренном функционалом Программ и условиями настоящего Соглашения;</li>
        <li>
          обеспечивать сохранность данных Пользователей, за исключением случаев, вызванных действиями третьих лиц или форс-мажорными обстоятельствами.
        </li>
      </ul>
      <p className="pb-2 indent-0">
        4.5. Пользователь принимает на себя обязательство по оплате сервисного сбора в случае подключения и использования счётчиков, передающих данные с
        помощью сим-карт. В случае неоплаты, Компания вправе ограничить функциональность, связанную с передачей и отображением данных по соответствующим
        приборам учёта.
      </p>
      <p className="pb-2 indent-0">
        4.6. В случае изменения условий оказания сервисных функций, связанных с передачей данных, Компания уведомляет Пользователя путём публикации информации
        в интерфейсе Программы. Продолжение использования функций означает согласие с изменениями.
      </p>
      <p className="pb-2 indent-0">
        4.7. Пользователь подтверждает, что осознаёт риски, связанные с передачей информации через интернет, и соглашается с тем, что Компания предпринимает
        разумные меры для защиты такой информации, включая организационно-технические средства защиты.
      </p>
      <p className="pb-2 indent-0">
        4.8. Пользователь выражает согласие на обработку персональных данных, необходимых для исполнения настоящего Соглашения, включая автоматизированную
        обработку, передачу информации операторам связи и иным лицам в рамках исполнения условий предоставления сервиса.
      </p>
      <p className="pb-2 indent-0">
        4.9. В случае внедрения новых функций или сервисов в Программе, Пользователь выражает согласие на возможное изменение условий использования
        соответствующих сервисов с уведомлением через интерфейс Платформы.
      </p>

      <p className="font-bold text-center py-4">5. ОБНОВЛЕНИЯ ПРОГРАММНОГО ОБЕСПЕЧЕНИЯ УСТРОЙСТВ</p>
      <p className="pb-2 indent-0">
        5.1. В целях настоящего Соглашения под программным обеспечением устройства понимается встроенное программное обеспечение, микропрограмма, прошивка,
        конфигурационные файлы, параметры работы, алгоритмы обмена данными и иные программные компоненты, обеспечивающие функционирование устройств MERIDIAN
        kolibri, подключенных к Платформе.
      </p>
      <p className="pb-2 indent-0">
        5.2. Пользователь понимает и соглашается с тем, что корректная работа устройств MERIDIAN kolibri может зависеть от актуальности установленного на
        устройстве программного обеспечения. Обновления программного обеспечения устройства могут быть необходимы для обеспечения стабильности работы,
        информационной безопасности, совместимости с Платформой, корректной передачи показаний, устранения ошибок, оптимизации энергопотребления, улучшения
        алгоритмов работы, поддержки новых функций, а также исполнения требований законодательства, операторов связи, интеграционных сервисов и иных
        технических условий.
      </p>
      <p className="pb-2 indent-0">
        5.3. Компания вправе разрабатывать, выпускать, направлять и устанавливать обновления программного обеспечения устройств MERIDIAN kolibri, в том числе
        дистанционно, с использованием доступных каналов связи устройства, Платформы, мобильного приложения, личного кабинета Пользователя, беспроводных сетей,
        каналов NB-IoT, Wi-Fi, Bluetooth или иных технически доступных способов.
      </p>
      <p className="pb-2 indent-0">
        5.4. Принимая настоящее Соглашение, Пользователь предоставляет Компании согласие на получение и установку обновлений программного обеспечения
        устройства, включая автоматические обновления, которые могут выполняться без дополнительного активного участия Пользователя, если такая возможность
        предусмотрена технической архитектурой устройства и Платформы.
      </p>
      <p className="pb-2 indent-0">
        5.5. Компания вправе устанавливать обновления программного обеспечения устройства без отдельного предварительного запроса согласия Пользователя в
        каждом конкретном случае, если такие обновления:
      </p>
      <ul className="list-disc pl-10 pb-2">
        <li>направлены на поддержание работоспособности устройства и Платформы;</li>
        <li>устраняют ошибки, сбои, уязвимости или иные технические недостатки;</li>
        <li>обеспечивают безопасность устройства, данных Пользователя и инфраструктуры Компании;</li>
        <li>улучшают стабильность передачи, хранения или обработки показаний;</li>
        <li>не лишают устройство основных заявленных функций;</li>
        <li>не ухудшают работоспособность устройства по сравнению с его назначением;</li>
        <li>не приводят к необоснованному расходу платного трафика Пользователя.</li>
      </ul>
      <p className="pb-2 indent-0">
        5.6. Компания информирует Пользователя о факте выпуска, установки или результате установки обновления одним или несколькими доступными способами: через
        push-уведомление, сообщение в Личном кабинете, запись в списке событий устройства, уведомление в мобильном приложении, сообщение на адрес электронной
        почты либо иным способом, предусмотренным функциональностью Платформы. В случае срочных обновлений, связанных с безопасностью, устранением критических
        ошибок или обеспечением работоспособности устройства, уведомление может быть направлено после установки обновления.
      </p>
      <p className="pb-2 indent-0">
        5.7. Пользователь понимает и соглашается с тем, что для установки обновлений устройство должно иметь техническую возможность связи с Платформой или
        мобильным приложением. Если устройство временно недоступно, отключено, находится вне зоны действия сети, не имеет доступа к Wi-Fi, NB-IoT, Bluetooth или
        иному каналу связи, обновление может быть установлено позднее, при восстановлении технической возможности передачи данных.
      </p>
      <p className="pb-2 indent-0">
        5.8. Пользователь обязуется не препятствовать установке обновлений программного обеспечения устройства, не выполнять действия, направленные на обход,
        блокировку, изменение или нарушение работы механизмов обновления, а также не использовать неофициальные версии программного обеспечения, не
        предоставленные Компанией.
      </p>
      <p className="pb-2 indent-0">
        5.9. Компания не несёт ответственности за невозможность установки обновления, задержку установки обновления, некорректное завершение обновления или
        временное ограничение работы устройства, если такие обстоятельства вызваны отсутствием связи, нестабильной сетью, недостаточным уровнем заряда
        элемента питания, вмешательством Пользователя или третьих лиц, нарушением инструкции по эксплуатации, несанкционированным изменением устройства,
        использованием неофициального программного обеспечения либо иными обстоятельствами, находящимися вне разумного контроля Компании.
      </p>
      <p className="pb-2 indent-0">
        5.10. В период установки обновления отдельные функции устройства или Платформы могут быть временно недоступны либо работать с ограничениями. Такие
        ограничения являются технически обусловленными и не считаются нарушением условий настоящего Соглашения, если после завершения обновления устройство
        сохраняет основные заявленные функции.
      </p>
      <p className="pb-2 indent-0">
        5.11. Компания принимает разумные меры для того, чтобы обновления программного обеспечения устройства не приводили к утрате показаний, пользовательских
        настроек и иных данных, необходимых для корректной работы устройства. При этом Пользователь понимает, что отдельные технические параметры устройства
        могут быть изменены или оптимизированы в результате обновления, если это необходимо для стабильной, безопасной и корректной работы устройства и
        Платформы.
      </p>
      <p className="pb-2 indent-0">
        5.12. При использовании Kolibri информация о срабатывании подключённого датчика протечки и уведомления в mira являются вспомогательной информационной
        функцией и не являются системой гарантированного аварийного оповещения или защиты от протечки. ООО «МЕРИДИАН» не гарантирует передачу события или
        доставку уведомления в реальном времени и не несёт ответственности за их непередачу, задержку или неполучение, а также связанные с этим последствия и
        убытки. Пользователь не должен использовать Kolibri и уведомления mira как единственное средство контроля возможной протечки. Настоящие ограничения
        применяются в пределах, допускаемых законодательством Российской Федерации.
      </p>

      <p className="font-bold text-center py-4">6. ОБРАБОТКА ПЕРСОНАЛЬНЫХ ДАННЫХ</p>
      <p className="pb-2 indent-0">
        6.1. Оператором персональных данных, обрабатываемых в рамках использования Программ, является Общество с ограниченной ответственностью «МЕРИДИАН»
        (ОГРН: 5087746158880, ИНН: 7734592378, юридический адрес: г. Москва, ул. Малая Калужская, д. 15, стр. 17).
      </p>
      <p className="pb-2 indent-0">
        6.2. Обработка персональных данных Пользователей осуществляется в соответствии с действующим законодательством Российской Федерации и Политикой
        конфиденциальности и обработки персональных данных, опубликованной на официальном сайте Компании по адресу:{' '}
        <a href="https://meridian.pro" target="_blank" rel="noopener noreferrer">
          https://meridian.pro
        </a>{' '}
        (далее — Политика).
      </p>
      <p className="pb-2 indent-0">
        6.3. Ознакомление с Политикой является обязательным условием использования Программ. Использование Программ, включая активацию функционала, регистрацию
        или отправку форм, означает согласие Пользователя с условиями обработки персональных данных, изложенными в Политике.
      </p>
      <p className="pb-2 indent-0">
        6.4. Согласие на обработку персональных данных предоставляется Пользователем в форме проставления чекбокса в соответствующей форме Программы,
        сопровождаемой активной гиперссылкой на текст согласия и Политику.
      </p>
      <p className="pb-2 indent-0">
        6.5. Перечень обрабатываемых персональных данных, цели, правовые основания, сроки и иные условия обработки установлены Политикой.
      </p>
      <p className="pb-2 indent-0">
        6.6. Пользователь обязуется предоставлять только достоверные и актуальные персональные данные. В случае изменения персональных данных Пользователь
        обязуется своевременно внести изменения в своей учётной записи или уведомить Компанию.
      </p>
      <p className="pb-2 indent-0">
        6.7. Компания принимает необходимые правовые, организационные и технические меры по защите персональных данных Пользователей от неправомерного или
        случайного доступа, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий.
      </p>
      <p className="pb-2 indent-0">
        6.8. Все запросы субъектов персональных данных обрабатываются Компанией в порядке, установленном Регламентом рассмотрения запросов субъектов
        персональных данных, утверждённым Компанией и размещённым на сайте Компании.
      </p>

      <p className="font-bold text-center py-4">7. ИНТЕЛЛЕКТУАЛЬНАЯ СОБСТВЕННОСТЬ</p>
      <p className="pb-2 indent-0">
        7.1. Все элементы Программ, включая, но не ограничиваясь: программным кодом, базой данных, дизайном интерфейсов, текстами, графическими элементами,
        логотипами, а также структурой и логикой взаимодействия между компонентами — являются объектами исключительных прав Компании и (или) её лицензиаров и
        охраняются в соответствии с законодательством Российской Федерации.
      </p>
      <p className="pb-2 indent-0">
        7.2. Пользователь получает неисключительное, непередаваемое, ограниченное право использовать Программы исключительно в личных целях в объёме,
        определённом настоящим Соглашением. Никакие положения настоящего Соглашения не подразумевают передачу исключительных прав на элементы Программ.
      </p>
      <p className="pb-2 indent-0">7.3. Пользователь не вправе:</p>
      <ul className="list-disc pl-10 pb-2">
        <li>
          копировать, воспроизводить, распространять, модифицировать, декомпилировать, изменять или иным способом использовать Программы, за исключением
          случаев, прямо предусмотренных законодательством или настоящим Соглашением;
        </li>
        <li>извлекать, систематизировать и/или использовать базу данных Программ или её части без письменного согласия Компании;</li>
        <li>использовать элементы Программ в коммерческих целях или для создания производных продуктов.</li>
      </ul>
      <p className="pb-2 indent-0">
        7.4. Нарушение Пользователем положений настоящего раздела может повлечь за собой привлечение к ответственности в соответствии с действующим
        законодательством Российской Федерации, включая, но не ограничиваясь: компенсацией убытков, блокировкой доступа, взысканием за незаконное
        использование интеллектуальной собственности.
      </p>
      <p className="pb-2 indent-0">
        7.5. Использование в Программах отдельных компонентов, прав на которые принадлежат третьим лицам (в том числе open source-библиотек), осуществляется на
        условиях соответствующих лицензий, соблюдение которых является обязательным для Пользователя при взаимодействии с такими компонентами.
      </p>
      <p className="pb-2 indent-0">
        7.6. Любое использование товарных знаков, фирменных наименований и других объектов индивидуализации Компании без её письменного согласия не допускается.
      </p>

      <p className="font-bold text-center py-4">8. РАЗРЕШЕНИЕ СПОРОВ</p>
      <p className="pb-2 indent-0">
        8.1. В случае возникновения любых разногласий или споров между Компанией и Пользователем, обязательным условием до обращения в суд является предъявление
        претензии — письменного обращения с изложением сути спора и требованиями.
      </p>
      <p className="pb-2 indent-0">
        8.2. Претензии физических лиц рассматриваются Компанией в срок до 10 (десяти) рабочих дней с даты получения. Претензии юридических лиц рассматриваются
        в срок до 30 (тридцати) календарных дней. В случае, если для рассмотрения требуется запрос дополнительных сведений у Пользователя, срок может быть
        продлён, но не более чем на 10 (десять) рабочих дней с момента уведомления Пользователя о продлении срока.
      </p>
      <p className="pb-2 indent-0">
        8.3. Претензия подаётся в письменной форме по электронной почте, указанной в разделе «Контакты». Претензия должна содержать сведения, позволяющие
        идентифицировать Пользователя и предмет спора, а также приложенные документы, подтверждающие изложенные доводы.
      </p>
      <p className="pb-2 indent-0">
        8.4. При невозможности разрешения спора в досудебном порядке, спор подлежит рассмотрению в судебном порядке по месту нахождения Компании, если иное не
        предусмотрено законодательством Российской Федерации.
      </p>

      <p className="font-bold text-center py-4">9. ИЗМЕНЕНИЕ УСЛОВИЙ СОГЛАШЕНИЯ</p>
      <p className="pb-2 indent-0">
        9.1. Компания оставляет за собой право в любое время изменять условия настоящего Соглашения, Политику конфиденциальности и иные связанные документы.
        Изменения вступают в силу с момента их публикации на Платформе, если иное не предусмотрено самими изменениями.
      </p>
      <p className="pb-2 indent-0">
        9.2. Продолжение использования Платформы Пользователем после внесения изменений в Соглашение означает согласие Пользователя с такими изменениями. В
        случае несогласия Пользователь обязан прекратить использование Платформы.
      </p>
      <p className="pb-2 indent-0">
        9.3. Компания вправе уведомить Пользователя о существенных изменениях в Соглашении, размещая соответствующее уведомление в интерфейсе Платформы,
        направляя его по электронной почте либо иным доступным способом, если Пользователь предоставил соответствующие контактные данные.
      </p>
      <p className="pb-2 indent-0">
        9.4. Пользователь обязуется самостоятельно и регулярно отслеживать актуальную версию Соглашения, размещённую на сайте Платформы, особенно перед
        использованием функционала, предполагающего внесение оплаты.
      </p>

      <p className="font-bold text-center py-4">Компания</p>
      <p className="pb-2 indent-0">ООО «МЕРИДИАН»</p>
      <p className="pb-2 indent-0">ОГРН: 5087746158880</p>
      <p className="pb-2 indent-0">ИНН: 7734592378</p>
      <p className="pb-2 indent-0">Юридический адрес: г. Москва ул. Малая Калужская, д.15, стр.17</p>
      <p className="pb-2 indent-0">
        Email для корреспонденции:{' '}
        <a href="mailto:info@meridian.pro">info@meridian.pro</a>
      </p>
    </div>
  );
};

export default Declaration;
